<template>
  <div v-if="visible && isHome && imagenPropaganda" class="popup-overlay animate__animated animate__fadeIn">
    <div class="popup-content glass animate__animated animate__zoomIn">
      <button class="close-btn" @click="cerrar" aria-label="Cerrar">
        <b-icon icon="close" size="is-small"></b-icon>
      </button>
      
      <div class="popup-scrollable">
        <div class="img-container">
          <img
            :src="urlPropaganda"
            @error="imagenError = true"
            v-if="!imagenError"
            alt="Promoción"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HttpService from '../Servicios/HttpService';
import Utiles from '../Servicios/Utiles';

export default {
  name: "PopupPrincipal",
  data() {
    return {
      visible: false,
      isHome: false,
      imagenPropaganda: '',
      imagenError: false
    };
  },
  computed: {
    urlPropaganda() {
      if (!this.imagenPropaganda) return '';
      if (this.imagenPropaganda.includes('http')) return this.imagenPropaganda;
      const apiBase = Utiles.regresarRuta().split('api')[0];
      return apiBase + this.imagenPropaganda;
    }
  },
  mounted() {
    this.cargarAjustes();
    this.checkRoute();
  },
  methods: {
    cargarAjustes() {
      HttpService.registrar('ajustes.php', { accion: 'obtener' })
        .then(res => {
          if (res && res.imagen_propaganda) {
            this.imagenPropaganda = res.imagen_propaganda;
            // Solo lo mostramos si ya verificamos que estamos en el home
            this.visible = this.isHome;
          }
        });
    },
    checkRoute() {
      const currentPath = this.$route?.path;
      this.isHome = currentPath === "/" || currentPath === "/inicio";
      // Si no es home, ocultamos de inmediato
      if (!this.isHome) this.visible = false;
    },
    cerrar() {
      this.visible = false;
    }
  },
  watch: {
    $route() {
      this.checkRoute();
      if (this.isHome && this.imagenPropaganda) this.visible = true;
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  padding: 20px;
}

.popup-content {
  position: relative;
  background: #ffffff;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  width: 90%; 
  max-width: 500px; /* Mantener un límite razonable en PC */
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 768px) {
  .popup-content {
    width: 85vw; /* 85% del ancho en móviles */
    max-width: none;
  }
}

.glass {
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.popup-scrollable {
  overflow-y: auto;
  padding: 5px;
}

/* Custom scrollbar */
.popup-scrollable::-webkit-scrollbar { width: 6px; }
.popup-scrollable::-webkit-scrollbar-track { background: transparent; }
.popup-scrollable::-webkit-scrollbar-thumb { background: #dbdbdb; border-radius: 10px; }

.close-btn {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 44px; /* Más grande para dedo humano */
  height: 44px;
  border-radius: 50%;
  border: 3px solid white; /* Borde para separar del fondo */
  background: #ff3860;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
  z-index: 20;
}

.close-btn:hover {
  transform: scale(1.1);
}

.event-message {
  text-align: center;
  font-size: 1.1rem;
  color: #363636;
  margin-bottom: 20px;
  line-height: 1.4;
}

.img-container {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.img-container img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
}

.animate__animated {
  animation-duration: 0.5s;
}
</style>

